import Tesseract from 'tesseract.js';

const resizeImage = (file, maxWidth = 1200) =>
    new Promise(resolve => {
        const img = new Image();
        const reader = new FileReader();

        reader.onload = e => (img.src = e.target.result);
        reader.readAsDataURL(file);

        img.onload = () => {
            const scale = Math.min(1, maxWidth / img.width);

            const canvas = document.createElement('canvas');
            canvas.width = img.width * scale;
            canvas.height = img.height * scale;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            canvas.toBlob(blob => resolve(blob), 'image/jpeg', 0.7);
        };
    });

const cropBottom = (file, cropRatio = 0.45) =>
    new Promise(resolve => {
        const img = new Image();
        const reader = new FileReader();

        reader.onload = e => (img.src = e.target.result);
        reader.readAsDataURL(file);

        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            const cropHeight = img.height * cropRatio;
            const startY = img.height - cropHeight;

            canvas.width = img.width;
            canvas.height = cropHeight;

            ctx.drawImage(
                img,
                0,
                startY,
                img.width,
                cropHeight,
                0,
                0,
                canvas.width,
                canvas.height
            );

            canvas.toBlob(blob => resolve(blob), 'image/jpeg', 0.7);
        };
    });

export const extractAmountFromImage = async (file) => {
    try {
        const resized = await resizeImage(file, 1200);
        const cropped = await cropBottom(resized, 0.45);

        const { data } = await Tesseract.recognize(
            cropped,
            'spa',
            {
                tessedit_char_whitelist: '0123456789.,$',
                preserve_interword_spaces: '1',
                logger: m => {
                    if (m.status === 'recognizing text') {
                        // console.log(`DARWIN OCR ${Math.round(m.progress * 100)}%`);
                    }
                }
            }
        );

        const text = data.text || '';

        const matches = text.match(/\$?\s?\d{1,3}(?:[.,]\d{3})*[.,]\d{2}/g);
        if (!matches) return null;

        const amounts = matches
            .map(m => {
                let clean = m.replace(/\$/g, '').trim();

                if (clean.includes(',') && clean.lastIndexOf(',') > clean.lastIndexOf('.')) {
                    clean = clean.replace(/\./g, '').replace(',', '.');
                } else {
                    clean = clean.replace(/,/g, '');
                }

                return parseFloat(clean);
            })
            .filter(n =>
                !isNaN(n) &&
                n > 1 &&
                n < 10000000
            );

        if (!amounts.length) return null;

        const detectedAmount = Math.max(...amounts);
        return detectedAmount;

    } catch (error) {
        return null;
    }
};
